import { render, staticRenderFns } from "./AssignmentDetailNav.vue?vue&type=template&id=b941ee1c"
import script from "./AssignmentDetailNav.vue?vue&type=script&lang=ts"
export * from "./AssignmentDetailNav.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports